<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.OTP.SHOW_OTP_INPUT"
    :handler="(data) => {
      otpStore.channel = data.channel || 'email';
      otpStore.requestId = data.requestId;
      otpStore.email = '';
      otpStore.phoneNumber = '';
      otpStore.otpCode = '';
      $refs.inputModal?.show();
    }"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.OTP.SHOW_OTP_VERIFICATION"
    :handler="() => {
      otpStore.otpCode = '';
      $refs.verifyModal?.show();
    }"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.OTP.OTP_VALIDATED"
    :handler="() => {
      $refs.verifyModal?.hide();
      $refs.inputModal?.hide();
    }"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.COUNTRY.SELECTED"
    :handler="(data) => {
      if (data?.id === 'otpPrefix') {
        otpStore.prefix = data.country.countryCode;
        otpStore.selectedPrefix = data.country.phonePrefix;
      }
    }"
  />

  <!-- modal input email/contact -->
  <DialogComponent
    ref="inputModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div class="p-6">
      <div class="text-xl font-bold mb-2 title-color">
        Entrez votre {{ otpStore.channel === 'email' ? 'email' : 'numéro WhatsApp' }}
      </div>
      <div class="text-sm text-slate-500 mb-6">
        Nous vous enverrons un code de vérification
      </div>

      <!-- input email -->
      <input
        class="inputComponent"
        v-if="otpStore.channel === 'email'"
        v-model="otpStore.email"
        label="Adresse email"
        type="email"
        placeholder="votre@email.com"
        :required="true"
      />

      <!-- input téléphone -->
      <template v-else>
        <div class="flex gap-2 mb-4">
          <button
            @click="$bus.emit($constants.EVENTS.COUNTRY.SELECT, { id: 'otpPrefix', countries: ['BJ', 'BF', 'CI', 'ML', 'SN', 'TG'] })"
            class="px-4 py-3 bg-slate-100 rounded-xl font-semibold text-sm min-w-[80px]"
          >
            {{ otpStore.selectedPrefix || '+229' }}
          </button>
          <input
            class="inputComponent"
            v-model="otpStore.phoneNumber"
            label="Numéro WhatsApp"
            type="tel"
            placeholder="01 01 01 01 01"
            :required="true"
          />
        </div>
      </template>

      <!-- boutons -->
      <div class="flex gap-3 mt-8">
        <button
          @click="$refs.inputModal?.hide(); $refs.verifyModal?.hide(); $bus.emit($constants.EVENTS.OTP.OTP_CANCEL)"
          class="flex-1! buttonComponent py-4 bg-slate-100! border border-primary text-primary!"
        >
          annuler
        </button>
        <button
          @click="$bus.emit($constants.EVENTS.OTP.OTP_SUBMIT_CONTACT, { email: otpStore.email, phoneNumber: otpStore.phoneNumber, prefix: otpStore.prefix })"
          class="flex-1! buttonComponent py-4"
        >
          continuer
        </button>
      </div>
    </div>
  </DialogComponent>

  <!-- modal vérification OTP -->
  <DialogComponent
    ref="verifyModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div class="p-6">
      <div class="text-xl font-bold mb-2 title-color">Vérification</div>
      <div class="text-sm text-slate-500 mb-6">
        Entrez le code envoyé sur votre {{ otpStore.channel === 'email' ? 'email' : otpStore.channel === 'sms'? 'numéro de téléphone': 'numéro WhatsApp' }}
        <span v-if="maskedEmail" class="font-semibold">
          ({{ maskedEmail }})
        </span>
        <span v-if="otpStore.phoneNumber && otpStore.channel === 'whatsapp'" class="font-semibold">
          (***{{ otpStore.phoneNumber.slice(-4) }})
        </span>
        <span v-if="otpStore.phoneNumber && otpStore.channel === 'sms'" class="font-semibold">
          (***{{ otpStore.phoneNumber.slice(-4) }})
        </span>
      </div>

      <!-- OTP input -->
      <div class="mb-6">
        <OtpInput class="h-18" v-model="otpStore.otpCode" :nb-char="5" />
      </div>

      <!-- boutons -->
      <div class="flex gap-3 mb-4">
        <button
                    @click="$refs.inputModal?.hide(); $refs.verifyModal?.hide(); $bus.emit($constants.EVENTS.OTP.OTP_CANCEL)"

          class="flex-1! buttonComponent py-4 bg-slate-100! border border-primary text-primary!"
        >
          annuler
        </button>
        <button
          @click="$bus.emit($constants.EVENTS.OTP.OTP_VERIFY, otpStore.otpCode)"
          class="flex-1! buttonComponent py-4"
          :disabled="!otpStore.otpCode || otpStore.otpCode.length !== 5"
        >
          vérifier
        </button>
      </div>

      <!-- renvoyer -->
      <button
        @click="$bus.emit($constants.EVENTS.OTP.OTP_RESEND)"
        class="w-full text-center text-sm text-primary font-semibold underline"
      >
        renvoyer le code
      </button>
    </div>
  </DialogComponent>
</template>

<script>
import { reactive, computed } from 'vue';

export default {
  name: 'OtpModal',

  setup() {
    const otpStore = reactive({
      channel: 'email',
      email: '',
      phoneNumber: '',
      prefix: '229',
      selectedPrefix: '+229',
      otpCode: '',
      requestId: null
    });

    const maskedEmail = computed(() => {
      if (otpStore.channel === 'email' && otpStore.email) {
        const [local, domain] = otpStore.email.split('@');
        if (local.length > 2) {
          return `${local[0]}${local[1]}***@${domain}`;
        }
        return otpStore.email;
      }
      return '';
    });

    return { otpStore, maskedEmail };
  }
};
</script>
